import api from "../../Plugins/axios";

export class AuthService {

    async login(params) {
        let error = null;
        let response = null;

        try {
            response = await api.post("auth/login", params);
        } catch (err) {
            error = err;
        }

        return [response, error];
    }

    async loginWithToken(token) {
        let error = null;
        let response = null;

        try {
            response = await api.post("auth/login-with-token", {
                token: token
            });
        } catch (err) {
            error = err;
        }

        return [response, error];
    }

    async logout() {
        let error = null;
        let response = null;

        try {
            response = await api.post("auth/logout");
        } catch (err) {
            error = err;
        }

        return [response, error];
    }
}
